import { render, staticRenderFns } from "./AuthenticationCode.vue?vue&type=template&id=8f76caca&"
import script from "./AuthenticationCode.vue?vue&type=script&lang=js&"
export * from "./AuthenticationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports